import Vue from 'vue'
import axios from 'axios'

export default {
    state: {
        originalTitle: 'Mixsii | Free Video Chat with Friends',
        defaultAlert: '▲',
        alert: undefined,
        divider: ' ',
        isVisible: true
    },

    actions: {},

    mutations: {
        'titleBarModel/updateAlert': function (state, data) {
            this.alert = data.alert;
        }
    }

}


// WEBPACK FOOTER //
// ./src/Common/TitleBarModel.js